import { connect } from 'react-redux'
import { getPlaybookType, getOnboardingInteractionId, getIsWidgetVerified, getOnboardingPlaybookId } from 'modules/playbook/selectors'
import { getEmbedId } from 'modules/org/selectors'
import BotWoohoo from 'layouts/OnboardingPlaybookWoohooStep/BotWoohoo'

const mapStateToProps = (state) => {
  return {
    playbookType: getPlaybookType(state),
    playbookId: getOnboardingPlaybookId(state),
    interactionId: getOnboardingInteractionId(state),
    embedId: getEmbedId(state),
    isWidgetInstalled: getIsWidgetVerified(state)
  }
}

export default connect(mapStateToProps, null)(BotWoohoo)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/BotWoohooStep/index.js